const EARTH_RADIUS_METERS = 6371000;

function toRadians(value) {
  return (Number(value) * Math.PI) / 180;
}

export function haversineDistanceMeters(pointA, pointB) {
  const lat1 = toRadians(pointA.latitude);
  const lat2 = toRadians(pointB.latitude);
  const deltaLat = toRadians(Number(pointB.latitude) - Number(pointA.latitude));
  const deltaLon = toRadians(Number(pointB.longitude) - Number(pointA.longitude));

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);

  return Math.round(EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export function validateGeofence({ currentLocation, store, settings = {} }) {
  const currentLatitude = Number(currentLocation?.latitude);
  const currentLongitude = Number(currentLocation?.longitude);
  const storeLatitude = Number(store?.latitude);
  const storeLongitude = Number(store?.longitude);

  if (!Number.isFinite(currentLatitude) || !Number.isFinite(currentLongitude)) {
    return {
      allowed: false,
      reason: "GPS location is required before punch can be saved.",
      distanceMeters: null,
      insideGeofence: false
    };
  }

  if (!store || !Number.isFinite(storeLatitude) || !Number.isFinite(storeLongitude)) {
    return {
      allowed: true,
      reason: "Punch saved, but store coordinates are missing.",
      distanceMeters: null,
      insideGeofence: false,
      exceptionRequired: true
    };
  }

  if (!store.geofenceEnabled) {
    return {
      allowed: true,
      reason: "Punch saved. Geofence is disabled for this store.",
      distanceMeters: haversineDistanceMeters(currentLocation, store),
      insideGeofence: false,
      exceptionRequired: false
    };
  }

  const distanceMeters = haversineDistanceMeters(currentLocation, store);
  const radiusMeters = Number(store.radiusMeters || store.allowed_radius_meters || 0);
  const insideGeofence = distanceMeters <= radiusMeters;
  if (!insideGeofence && settings.outsideGeofenceMode === "block") {
    return {
      allowed: false,
      reason: "You are outside the store geofence. Punch is blocked by company policy.",
      distanceMeters,
      insideGeofence,
      exceptionRequired: true
    };
  }

  return {
    allowed: true,
    reason: insideGeofence
      ? "Inside store geofence."
      : "Outside geofence, punch saved and flagged for admin review.",
    distanceMeters,
    insideGeofence,
    exceptionRequired: !insideGeofence
  };
}
